module.exports = __webpack_public_path__ + "datahub/img/雾霾.54708c2c.png";